import "../../../styles/hubweb/hubProductView.scss";
import "../../../styles/page/shoppingCart.scss";

import Icon, { iconColor, iconTypes } from "../../common/components/Icon";
import { addNewProductToRegister, addProducedQty, getHubProducts, showProductionListPdf, submitEditedProducts } from "../actions/hubProduction.js";

import CounterField from "../../common/components/CounterField.jsx";
import DropDownList from "../../common/components/DropDownList";
import { Localization } from "../../common/util/localization.jsx";
import Modal from "../../common/components/Modal.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../common/components/ResponsiveColumn";
import ResponsiveRows from "../../common/components/ResponsiveRows";
import Scroll from "../../common/components/Scroll.jsx";
import { connect } from "react-redux";
import moment from "moment";
import { scssVariables } from "../../common/util/config.jsx";
import { setDropDown } from "../../common/actions/modal.js";

/**
 * A counter designed for ordered items
 * 
 * @param {object} props
 * @returns {node}
 */
function CounterProducedQty({customerId, productId, addProducedQty, registeredQty}) {

    /**
     * updates produced qty
     * 
     * @param {object} change
     * @returns {undefiend}
     */
    function onEditProducedQty(change) {
        addProducedQty(customerId, productId, change.value); 
    }

    return (
        <CounterField onEdit={onEditProducedQty} value={registeredQty} border={false} invisibleBackground={true} alwaysShowInputField={true} minValue={-5}/>
    );
}
CounterProducedQty.propTypes = {
    customerId: PropTypes.string,
    productId: PropTypes.string,
    addProducedQty: PropTypes.func,
    registeredQty: PropTypes.number
};


class HubProductionListModal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.prepareCart = this.prepareCart.bind(this);
        this.onSaveChanges = this.onSaveChanges.bind(this);
        this.onEditProductChoice = this.onEditProductChoice.bind(this);
        this.onClickShowPdf = this.onClickShowPdf.bind(this);
        this.getProducedQty = this.getProducedQty.bind(this);
    }

    componentDidMount() {
        (async () => {
            await this.props.getHubProducts(this.props.hubId);
        })();
    }

    handleClickOutside() {
        if (this.props.onCloseModal) {
            this.props.onCloseModal();
        }
    }

    getProducedQty(customerId, productId) 
    {
        const {
            editedCustomer,
        } = this.props;
       
        const product = editedCustomer && editedCustomer.customerId === customerId ? editedCustomer.products.find(p => p.productId === productId) : null;

        if(product != null)
        {
            return product.producedQty;
        }
        else
        {
            return 0;
        }
    }

    prepareCart() {
        const {
            customer,
            addProducedQty,
        } = this.props;
       
        const prodNodes = customer.products.map((product) => 
            (<div key={product.productId} className="product-view-list-item-wrapper" draggable={false}>
                <div className="container">
                    <div className="list">
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn xs={0} lg={3}>
                                <div className="label14 product-view-list-item-prd-info_multiline_narrow" style={{ display: "flex", alignItems: "center" }}>
                                    <div style={{ width: "100%" }}>
                                        {product.productName}
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={1} lg={1}>
                                <div className="label14 product-view-list-item">
                                    <div style={{ width: "100%" }}>
                                        {product.epdNo}
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={1} lg={2}>
                                <div className="label14 product-view-list-item-price">
                                    <div style={{ width: "100%" }}>
                                        {product.qtyToBeProduced}
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={1} lg={2}>
                                <div className="label14 product-view-list-item-price">
                                    <div style={{ width: "100%" }}>
                                        {product.qtyProduced}
                                    </div>
                                </div>
                            </ResponsiveColumn>  
                            <ResponsiveColumn xs={1} lg={3}>
                                <div className="product-view-list-item-counter-field" style={{ float: "none"}}>
                                    <CounterProducedQty  addProducedQty={addProducedQty} productId={product.productId} customerId={customer.customerId} registeredQty={this.getProducedQty(customer.customerId, product.productId)} />
                                </div>
                            </ResponsiveColumn> 
                            <ResponsiveColumn xs={1} lg={1}>
                                <div className="label14 product-view-list-item">
                                    <div style={{ width: "100%" }}>
                                        {product.lastUpdatedDate ? moment(product.lastUpdatedDate).format("HH:mm:ss") : ""}
                                    </div>
                                </div>
                            </ResponsiveColumn>                           
                        </ResponsiveRows>
                    </div>
                </div>
            </div>));

        return prodNodes;
    }

    onClickShowPdf() {
        const {
            customer,
            showProductionListPdf,
            token,
        } = this.props;

        showProductionListPdf(customer, token);
    }

    onSaveChanges() {
        const {
            submitEditedProducts,
            onRefreshModal
        } = this.props;
        (async () => {
            await submitEditedProducts();
            onRefreshModal(); 
        })();
    }

    onEditProductChoice(choice)
    {
        const {
            customer,
            hubProducts,
            addNewProductToRegister,
            onRefreshModal
        } = this.props;

        const prod = hubProducts.find(p => p.productId === choice.productId);    

        (async () => {
            await addNewProductToRegister(customer.customerId, prod.productId, prod.epdNo, prod.productName);
            onRefreshModal(); 
        })();        
    }

    calculateListHeight() {
        // const {
        //     height,
        // } = this.props;

        let listHeight = 700;

        //top menu
        listHeight -= parseInt(scssVariables.menuHeight);
        //progressbar
        listHeight -= parseInt(scssVariables.progresbarHeight);
        //second menu
        listHeight -= parseInt(scssVariables.menuHeight);
        //bottom section
        listHeight -= parseInt(scssVariables.hubCartDetailHeight);

        return listHeight;
    }


    render() {
        const {
            localization,
            onCloseModal,
            title,
            width,
            customer,
            hubProducts,
        } = this.props;

        const listHeight = this.calculateListHeight();

        const freshFoodSort = hubProducts.map(p => ({ value: p.productId, label: p.productName }));

        const freshFoodSortNotInList = freshFoodSort.filter(v => !customer.products.some(p => p.productId === v.value));
        const newProduct = { productId: ""};

        return (
            <Modal onCloseModal={onCloseModal} width={width} onClickOutside={this.handleClickOutside}>
                <div className="hub-product-modal-wrapper">
                    <div className="product-modal-header">
                        <div className="header-content">
                            <div className="header-left">
                                <div className="header-detail">{title}</div>
                                <div className="header-name-date">
                                    <div className="header-cus-name" style={{flex : "2"}}>{`Butikk: ${customer.storeName}`}</div>
                                    <div className="header-cus-name" style={{flex : "1"}}>{`${localization.text("hub","production","departmentStoreNo")} ${customer.departmentStoreNo}`}</div>
                                    <div className="header-cus-name" style={{flex : "1"}}>{`${localization.text("hub","production","address")}: ${customer.streetAddress}`}</div>
                                    <div className="header-date">{`Dato: ${moment(customer.productionDate).format("DD.MM.YYYY")}`}</div>
                                </div>
                            </div>
                            <button style={{ marginLeft: "auto" }} className="btn circular" onClick={onCloseModal}>
                                <Icon type={iconTypes.x} color={iconColor.red} />
                            </button>
                        </div>
                    </div>

                    <div className="product-modal-body">
                        <div className={"product-view-header-wrapper"} >
                            <div style={{marginTop:"6px", marginBottom:"7px"}}>
                                <ResponsiveRows gutters={false}>
                                    <ResponsiveColumn xs={1} lg={3}>
                                        <div className="product-view-list-header" style={{width:"100%"}}>
                                            {localization.text("hub","production","description")}
                                        </div>
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={1} lg={1}>
                                        <div className="product-view-list-header" style={{width:"100%"}}>
                                            {localization.text("hub","production","epdNo")}
                                        </div>
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={1} lg={2}>
                                        <div className="product-view-list-header"  style={{marginLeft:"20px"}}>
                                            {localization.text("hub","production","qtyToProduction")}
                                        </div>
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={1} lg={2}>
                                        <div className="product-view-list-header" style={{marginLeft:"20px"}}>
                                            {localization.text("hub","production","qtyDelivered")}
                                        </div>
                                    </ResponsiveColumn>   
                                    <ResponsiveColumn xs={1} lg={3}>
                                        <div className="product-view-list-header" style={{marginLeft:"20px"}}>
                                            {localization.text("hub","production","qtyProduced")}
                                        </div>
                                    </ResponsiveColumn>      
                                    <ResponsiveColumn xs={1} lg={1}>
                                        <div className="product-view-list-header" style={{width:"100%"}}>
                                            {localization.text("hub","production","lastUpdated")}
                                        </div>
                                    </ResponsiveColumn>                               
                                </ResponsiveRows>
                            </div>
                        </div>
                        <Scroll className={"shopping-cart-list-wrapper"} style={{height:`${listHeight}px`}}>
                            {this.prepareCart()}
                        </Scroll>
                    </div>

                    <div className="product-modal-footer">
                        <div >
                            <button className="btn" onClick={this.onClickShowPdf} style={{ width: "200px" }}>
                                <Icon type={iconTypes.print} />{localization.text("hub", "production", "print")}
                            </button>
                        </div>
                        <div className="product-modal-footer-newprd">
                            <div className="product-modal-footer-newprd-lbl">{localization.text("hub", "production", "newProduct")}:</div>
                            <div className="product-modal-footer-newprd-drop">
                                <DropDownList options={freshFoodSortNotInList} onEdit={this.onEditProductChoice} source={newProduct} property={"productId"} value={newProduct.productId} setDropDown={this.props.setDropDown} placeholder={localization.text("hub", "production", "selectaprod")}/>
                            </div>                            
                        </div>
                        <div className="product-modal-footer-button" style={{ justifyContent: "flex-end"}}  >
                            <button style={{ flexGrow: 0.1, marginRight: "15px" }} className="btn" onClick={onCloseModal}>
                                <Icon type={iconTypes.x} color={iconColor.red} /> {localization.text("hub", "production", "undo")}
                            </button>
                            <button style={{ flexGrow: 0.1 }} className="btn" onClick={this.onSaveChanges}>
                                {localization.text("hub", "production", "confirm")}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}
HubProductionListModal.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    localization: Localization.propTypes.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    onRefreshModal: PropTypes.func.isRequired,
    title: PropTypes.string,
    width: PropTypes.number.isRequired,
    setDropDown: PropTypes.func.isRequired,
    customer: PropTypes.object.isRequired,
    addProducedQty: PropTypes.func.isRequired,
    submitEditedProducts: PropTypes.func.isRequired,
    addNewProductToRegister: PropTypes.func.isRequired,
    getHubProducts: PropTypes.func.isRequired,
    hubId: PropTypes.number.isRequired,
    hubProducts: PropTypes.array.isRequired,
    showProductionListPdf : PropTypes.func.isRequired,
    token: PropTypes.string.isRequired,
    editedCustomer: PropTypes.object.isRequired,
    //height: PropTypes.number.isRequired,
};

const mapStateToProps = () => {
    return (state) => ({
        isLoading: state.singleChainSortiment.isLoading,
        hubId: state.authentication.hubId,
        token: state.authentication.token,
        hubProducts: state.freshFoodHub.hubProducts
    });
};

const mapDispatchToProps = {
    setDropDown,
    addNewProductToRegister,
    getHubProducts,
    submitEditedProducts,
    addProducedQty,
    showProductionListPdf,
};

export default connect(mapStateToProps, mapDispatchToProps)(HubProductionListModal);
